import dayjs from "dayjs";

const calculateDateRange = (id) => {
  const today = dayjs();

  switch (id) {
    case "yesterday":
      return {
        from: today.subtract(1, "day").startOf("day").toDate(),
        to: today.subtract(1, "day").endOf("day").toDate(),
      };
    case "today":
      return {
        from: today.startOf("day").toDate(),
        to: today.endOf("day").toDate(),
      };
    case "tomorrow":
      return {
        from: today.add(1, "day").startOf("day").toDate(),
        to: today.add(1, "day").endOf("day").toDate(),
      };
    case "current-week":
      return {
        from: today.startOf("week").toDate(),
        to: today.endOf("week").toDate(),
      };
    case "next-week":
      return {
        from: today.add(1, "week").startOf("week").toDate(),
        to: today.add(1, "week").endOf("week").toDate(),
      };
    case "current-month":
      return {
        from: today.startOf("month").toDate(),
        to: today.endOf("month").toDate(),
      };
    case "next-month":
      return {
        from: today.add(1, "month").startOf("month").toDate(),
        to: today.add(1, "month").endOf("month").toDate(),
      };
    case "all":
    case "manual":
    default:
      // Leave null to represent no bounds, or keep existing values for manual
      return { from: null, to: null };
  }
};

export default calculateDateRange;
